import { arraymove, sortByField } from "../array";
import uiLanguagesJson from "../../assets/uiLanguages.json";
import multiLangConfig from "./config.json";

export const LANG_CODE_EN = multiLangConfig.LANG_CODE_EN;

export const DEFAULT_LANGUAGE = LANG_CODE_EN;

export const UL_LANGUAGES = sortByField(uiLanguagesJson, "key");
arraymove(UL_LANGUAGES, UL_LANGUAGES.findIndex((l) => l.id === DEFAULT_LANGUAGE), 0);

export const COOKIE_KEY_I_18_NEXT = "i18next";

export const I18N_NAMESPACE = {
  common: "common",
  translate: "translate",
  sw: "sw",
  books: "books",
  authors: "authors",
  featuredSearch: "featuredSearch",
};

export const I18N_NAMESPACES = Object.values(I18N_NAMESPACE);

export const I18N_NAMESPACES_LANDING = [I18N_NAMESPACE.common, I18N_NAMESPACE.sw];
